import { DonationContainer } from '../../../donation/DonationContainer'

import { FundraiserDetailsCard } from './FundraiserDetailsCard/FundraiserDetailsCard'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery, useRequiredParams } from '@percent/partner-dashboard/common/hooks'
import { Box, Loader } from '@percent/lemonade'
import { ErrorView } from '@percent/partner-dashboard/common/components'

export function FundraiserDetailContainer() {
  const { fundraiserId } = useRequiredParams()
  const { fundraisersService } = useServices()
  const [{ data, isLoading, errorMessage }] = useQuery(fundraisersService.getFundraiserDetails, {
    fundraiserId
  })

  if (isLoading) {
    return <Loader />
  }

  if (errorMessage) {
    return <ErrorView errorMessage={errorMessage} />
  }

  return (
    <Box>
      {data && (
        <>
          <FundraiserDetailsCard fundraiserData={data} />
          <DonationContainer fundraiserName={data.page.title} />
        </>
      )}
    </Box>
  )
}
